import { OnInit, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { AgroConfigBackEnd } from './agro.backend.util';
import { ModelContext } from './agro.model.context';
import { ParametroModel } from '../model/parametro.model';


@Injectable()
export class AgroHttpUtil implements OnInit {

  private URL_APLICACAO: string;
  private URL_TAUTH: string;

  constructor(private config: AgroConfigBackEnd, private models : ModelContext) {
    this.URL_APLICACAO = config.getBackEnd();
    this.URL_TAUTH = config.getTauth();
  }

  ngOnInit() { }

  /**
   * Retorna URL padrão dos serviços Back-end.
   */
  public getURLService(name : string): string {
    return this.URL_APLICACAO + this.models.getContext(name);
  }

  public getURLAplicacao(): string {
    return this.URL_APLICACAO;
  }

  public getURLServiceTauth(name : string): string {
    return this.URL_TAUTH + this.models.getContext(name);
  }

  public getURLTauth(): string {
    return this.URL_TAUTH;
  }

  /**
   * Retorna Parametros para Requisição.
   * @param params 
   */
  public getParams(params: ParametroModel[]): HttpParams {

    let httpParams = new HttpParams();

    if (params) {
      for (let param of params) {
        httpParams = httpParams.append(param.chave, param.valor);
      }
    }

    return httpParams;
  }
}
